import { render, staticRenderFns } from "./ViewArea.vue?vue&type=template&id=42c9f388&scoped=true&"
import script from "./ViewArea.vue?vue&type=script&lang=js&"
export * from "./ViewArea.vue?vue&type=script&lang=js&"
import style0 from "./ViewArea.vue?vue&type=style&index=0&id=42c9f388&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c9f388",
  null
  
)

export default component.exports